import React from 'react';
import { useBarChartContext } from '../BarChart/context';

export type ChartType = 'bar' | 'line' | 'area';

export const ChartTypeContext = React.createContext<ChartType | undefined>(undefined);

export const useChartType = (): ChartType | undefined => {
  return React.useContext(ChartTypeContext);
};

export const useResolvedChartContext = () => {
  const chartType = useChartType();

  switch (chartType) {
    case 'bar':
      return useBarChartContext();
    default:
      return undefined;
  }
};

export function useResolvedProp<T>(prop: T | undefined, contextValue: T | undefined, defaultValue?: T): T | undefined {
  if (prop !== undefined) return prop;
  if (contextValue !== undefined) return contextValue;
  return defaultValue;
}
